import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    grid-template-columns: min-content 1fr;\n    align-items: center;\n    gap: 0;\n    height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import Columns from '../columns'; // Varnish menu Item columns for text with an icon.

var IconMenuItemColumns = styled(Columns).attrs({
  count: 2
})(_templateObject());
export default IconMenuItemColumns;